// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ikxo","title":"styles_title__woMvc"};